import { useI18n } from 'hooks/useI18n';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const MethodologyExperience: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const data = [
    { exp: 'Not specified', share: 6.142611683848798 },
    { exp: '<2y', share: 17.325315005727376 },
    { exp: '2-5y', share: 23.883161512027492 },
    { exp: '5-10y', share: 21.83562428407789 },
    { exp: '>10y', share: 30.813287514318443 }
  ];

  return (
    <div>
      <StyledRecharts className="methodology">
        <ResponsiveContainer width={380} height={200}>
          <BarChart data={data}>
            <XAxis
              type="category"
              dataKey="exp"
              tickLine={false}
              label={{
                value: t('methodology.experience.years'),
                position: 'insideBottom',
                offset: 0,
                style: { transformOrigin: 'center center' }
              }}
            />
            <YAxis
              tickLine={false}
              width={90}
              tickMargin={5}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
              padding={{ bottom: 10 }}
              label={{
                value: t('methodology.experience.share'),
                position: 'insideLeft',
                offset: 40,
                angle: -90
              }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-x"
            />

            <Bar dataKey="share" barSize={8} radius={5} fill="#4292C6"></Bar>
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyExperience;
